import { render } from "./callout.vue?vue&type=template&id=68cc5a2c"
import script from "./callout.vue?vue&type=script&lang=js"
export * from "./callout.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/drop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__